import { Injectable } from '@angular/core';
import { LogoutService } from '../services/authentication/logout.service';
import { SoftwareOptionsForCompany } from '@shared/enums';
import { GlobalSettingsService } from '@core/globalSettings.service';
import { CompanyType } from '@nodeModules/@itero/auth-angular';
import { CookieReadWriteService } from '../services/authentication/cookie-read-write.service';
import { PlatformLoginStateService } from '../services/platform-login/platform-login-state.service';
import { CompanyAccessService } from '../services/company-access/company-access.service';

@Injectable()
export class RootGuard {
	constructor(
		private readonly logoutService: LogoutService,
		private readonly globalSettingsService: GlobalSettingsService,
		private readonly cookieService: CookieReadWriteService,
		private readonly platformLoginStateService: PlatformLoginStateService,
		private readonly companyAccessService: CompanyAccessService
	) {}

	async canActivate(): Promise<boolean> {
		if (this.platformLoginStateService.isActive()) {
			// Logon-as: the BFF already authorized access; the token is the admin's, not the customer's.
			if (this.cookieService.businessCookie.cookie?.impersonatedContactId) {
				return true;
			}

			return this.companyAccessService.verifyOrRedirect();
		}

		const swo = this.globalSettingsService.get().companySoftwareOptions;
		const isLab = (this.cookieService.businessCookie.cookie.companyType as CompanyType) === CompanyType.Lab;

		if (swo.includes(SoftwareOptionsForCompany.cswo_UseMiflPlatform) && isLab) {
			return true;
		}

		return this.logoutService.logoutWithoutSessionInvalidation();
	}
}
